import { color } from 'asserts/styles/colors';
import DefaultButton from 'components/button/DefaultButton';
import { ButtonWrapper, InputWrapper } from 'components/customer/Reference';
import DefaultInput from 'components/input/DefaultInput';
import DefaultSelectMenu from 'components/selectMenu/DefaultSelectMenu';
import styled from 'styled-components';

const ReferenceSkeleton = () => {
  return (
    <>
      <ButtonWrapper>
        {Array(6)
          .fill(null)
          .map((_, index) => (
            <DefaultButton key={index} text="" loading />
          ))}
      </ButtonWrapper>
      <InputWrapper>
        <DefaultInput name="search" search height="middle" />
        <DefaultSelectMenu
          defaultValue=""
          options=""
          value=""
          size="medium"
          onChange={() => console.log('')}
        />
      </InputWrapper>
      <InnerWrppaer>
        {Array(4)
          .fill(null)
          .map((_, index) => (
            <DataWrapper key={index}>
              <div></div>
              <div></div>
              <div></div>
            </DataWrapper>
          ))}
      </InnerWrppaer>
    </>
  );
};

export default ReferenceSkeleton;

export const DataWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 16px;
  width: 435px;

  div {
    width: 435px;
    height: 22px;
    background: ${color.gray200};
    border-radius: 8px;
  }

  div:first-of-type {
    height: 240px;
    border-radius: inherit;
  }

  div:last-of-type {
    width: 120px;
    height: 32px;
    border-radius: 24px;
  }
`;

const InnerWrppaer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 48px 20px;
`;
